export default __webpack_public_path__ + "static/media/icon_clover_apple_pay.fd67d15e.png";